module.exports = __webpack_public_path__ + "static/night-sky-9c0f9c52f9cda9aeff0c18fc84feab3a.jpg";